import { Outlet, useLocation } from 'react-router-dom'

import unloggedBackground from '@/assets/background/SocialMirrorOnboardingBG.png'
import backgroundImage1 from '@/assets/wecheckLights/1.png'
import backgroundImage2 from '@/assets/wecheckLights/2.png'
import { AppRoutes } from '@/constants/appRoutes'
import { useCheckSession } from '@/hooks/Auth'
import { useStatusGuard } from '@/hooks/StatusGuard/useStatusGuard'

import { FormsScreensHeader } from '../FormsScreensHeader/FormsScreensHeader'

export const UnloggedScreenLayout = () => {
  const location = useLocation()
  useCheckSession()

  useStatusGuard()

  const showInitialBG =
    location.pathname === AppRoutes.registerStart ||
    location.pathname === AppRoutes.registerEmailVerification ||
    location.pathname === AppRoutes.login ||
    location.pathname === AppRoutes.forgotPassword ||
    location.pathname === AppRoutes.forgotPaswordCheckYourInbox ||
    location.pathname === AppRoutes.setPassword ||
    location.pathname === AppRoutes.stripePaymentRedirect

  return (
    <div className="relative flex flex-col w-full h-screen bg-white">
      <FormsScreensHeader />
      {showInitialBG ? (
        <div
          className="fixed inset-0 bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url(${unloggedBackground})`,
            zIndex: -1,
            height: '100%',
          }}
        ></div>
      ) : (
        <>
          <div
            className="fixed inset-0 bg-cover bg-no-repeat bg-center"
            style={{
              backgroundImage: `url(${backgroundImage1})`,
              zIndex: -1,
              height: '100%',
            }}
          ></div>
          <div
            className="absolute inset-0 bg-cover bg-no-repeat bg-center animate-bg-scroll"
            style={{
              backgroundImage: `url(${backgroundImage2})`,
              zIndex: -1,
              height: '100%',
            }}
          ></div>
        </>
      )}
      <div className="flex w-full h-full justify-center items-center bg-white  px-32 max-sm:px-4 max-lg:basis-full">
        <Outlet />
      </div>
    </div>
  )
}
